import Axios from 'axios';
import React, { useState, useEffect } from 'react';

import { getData, getDataWithComp, formatCurrency, getAlert, deleteData, parseCurrency, useEscapeClose } from '../../../utils/SamuiUtils';

const CloseVansaleForAccountModal = ({ isVansaleCloseForAccount, hideVansaleCloseForAccount, pkId, docStatus, setDocStatus, callInitialize }) => {

    // ข้อมูล PKList
    const [pkDocNo, setPkDocNo] = useState("");
    const [deliveryLineName, setDeliveryLineName] = useState("");
    const [deliveryCarNo, setDeliveryCarNo] = useState("");

    // เก็บค่าจำนวนเงิน
    const [cash, setCash] = useState(0);
    const [transfer, setTransfer] = useState(0);
    const [cheque, setCheque] = useState(0);
    const [fee, setFee] = useState(0);
    const [credit, setCredit] = useState(0);
    const [unpaid, setUnpaid] = useState(0);

    // รายการกรอกจำนวนเงินสดที่ได้รับจากลูกค้า (PKList_CloseMoney)
    const [pkCloseMoneyList, setPkCloseMoneyList] = useState([]);
    const [totalCash, setTotalCash] = useState(0);

    // Disabled ปุ่มหลังกดยืนยัน
    const [isDisabled, setIsDisabled] = useState(false);

    // Confirm Dialog สำหรับยืนยันการบันทึกรอบอีกนึง
    const [showConfirmDialog, setShowConfirmDialog] = useState(false);

    // แสดงยอดรวม
    const [totalSell, setTotalSell] = useState(0);

    useEscapeClose(isVansaleCloseForAccount, hideVansaleCloseForAccount);

    useEffect(() => {
        initialize();
    }, [pkId]);

    const initialize = async () => {
        try {
            // ข้อมูล PKList
            const pkDataList = await getDataWithComp('API_0801_PKList_H', `AND Doc_Id = ${pkId}`);
            if (pkDataList && pkDataList.length > 0) {
                const pkData = pkDataList[0];
                setPkDocNo(pkData.Doc_No);
                setDeliveryLineName(pkData.DL_LineName);
                setDeliveryCarNo(pkData.PK_Car_No);
                setDocStatus(pkData.Doc_Status);
            }

            // รายการกรอกจำนวนเงินสดที่ได้รับจากลูกค้า (PKList_CloseMoney)
            const pkCloseMoneyList = await getData('PKList_CloseMoney', `PKList_Id = ${pkId}`);
            if (pkCloseMoneyList && pkCloseMoneyList.length > 0) {
                const mappedData = mapCloseMoneyData(pkCloseMoneyList[0]);
                setPkCloseMoneyList(mappedData);
            }

            await onLoadAmountSell(pkId);

            if (docStatus === 3) {
                setIsDisabled(false);
            } else {
                setIsDisabled(true);
            }
        } catch (error) {
            getAlert('FAILED', error.message);
        }
    };

    // ดึงข้อมูลจำนวนขาย
    const onLoadAmountSell = async (docId) => {
        try {
            // กำหนดค่าเริ่มต้น
            let cash = 0, transfer = 0, credit = 0, cheque = 0, unpaid = 0;

            // ดึงรายการ SO ตาม PKDoc_Id
            //const formPkList = await getDataWithComp("API_0802_PKList_D", `AND Doc_Id = ${docId} ORDER BY DL_Queue ASC`);
            const formSoList = await getDataWithComp(
                "API_0701_SO_H",
                `AND Doc_Status <> 13 AND Ref_DocID = ${docId} ORDER BY Doc_No ASC`
            );

            if (formSoList && formSoList.length > 0) {
                for (const so of formSoList) {

                    switch (so.Doc_Status_Paid_Type) {
                        case 1: // สด
                            cash += so.Pay_Total || 0;
                            break;
                        case 2: // โอน
                            transfer += so.Pay_Total || 0;
                            break;
                        case 3: // เช็ค
                            cheque += so.Pay_Total || 0;
                            break;
                        case 4: // เครดิต
                            credit += so.NetTotal || 0;
                            break;
                        case 5: // ค้างจ่าย
                            unpaid += so.NetTotal || 0;
                            break;
                        case 6: // ชำระหลายช่องทาง

                            // ค้นหาข้อมูลจาก Pay_History และยอดการกระจายเงินตามประเภทการชําระเงิน
                            const payHist = await getData(
                                "Pay_History",
                                `DocCode_Id = 7 AND Doc_Id = ${so.Doc_ID}`
                            );

                                            if (payHist && payHist.length > 0) {
                                                // eslint-disable-next-line no-loop-func
                                                payHist.forEach((ph) => {
                                                    switch (ph.Pay_Type) {
                                                        case 1: cash += ph.Pay_Amount || 0; break;
                                                        case 2: transfer += ph.Pay_Amount || 0; break;
                                                        case 3: cheque += ph.Pay_Amount || 0; break;
                                                        case 7: fee += ph.Pay_Amount || 0; break;
                                                        default:
                                                            break;
                                                    }
                                                });
                                            }

                            break;
                        default:
                            break;
                    }

                    // เพิ่ม Business สำหรับใบขายที่ยังจ่ายเงินไม่ครบ ต้องเอามา + เพิ่มเติมกับประเภทค้างจ่าย
                    if ((so.Doc_Status_Paid_Type === 1 || so.Doc_Status_Paid_Type === 2 || so.Doc_Status_Paid_Type === 3 || so.Doc_Status_Paid_Type === 6) && so.Doc_Status_Paid === 2) {
                        let calUnpaid = parseCurrency(so.NetTotal) - parseCurrency(so.Pay_Total);
                        unpaid += calUnpaid;
                    }
                }
            }

            // คำนวณยอดรวมทั้งหมด
            const totalSell = cash + transfer + credit + cheque + unpaid + fee;

            // เซ็ตค่าลง state
            setCash(cash);
            setTransfer(transfer);
            setFee(fee);
            setCredit(credit);
            setCheque(cheque);
            setUnpaid(unpaid);
            setTotalSell(totalSell);
        } catch (error) {
            getAlert('FAILED', error.message);
        }
    };

    // Map ข้อมูลที่ได้จาก API
    const mapCloseMoneyData = (pkCloseMoneyList) => {
        return [
            { id: pkCloseMoneyList.PKClose_Money_Id, field: "B1000", label: "1,000 บาท", image: "https://mpics.mgronline.com/pics/Images/561000012686801.JPEG", type: "banknote", value: pkCloseMoneyList.B1000, multiplier: 1000 },
            { id: pkCloseMoneyList.PKClose_Money_Id, field: "B500", label: "500 บาท", image: "https://media.komchadluek.net/uploads/images/contents/w1024/2023/07/tkQ9oQJliLeNIAyfuTOC.webp?x-image-process=style/lg-webp", type: "banknote", value: pkCloseMoneyList.B500, multiplier: 500 },
            { id: pkCloseMoneyList.PKClose_Money_Id, field: "B100", label: "100 บาท", image: "https://upload.wikimedia.org/wikipedia/th/6/62/100THB-17th-Banknote-Front.jpg", type: "banknote", value: pkCloseMoneyList.B100, multiplier: 100 },
            { id: pkCloseMoneyList.PKClose_Money_Id, field: "B50", label: "50 บาท", image: "https://f.ptcdn.info/483/036/000/nwcvpyyw1Gfz5KkBn3-o.jpg", type: "banknote", value: pkCloseMoneyList.B50, multiplier: 50 },
            { id: pkCloseMoneyList.PKClose_Money_Id, field: "B20", label: "20 บาท", image: "https://assets.brandinside.asia/uploads/2022/01/20-%E0%B8%9A%E0%B8%B2%E0%B8%97.jpeg", type: "banknote", value: pkCloseMoneyList.B20, multiplier: 20 },
            { id: pkCloseMoneyList.PKClose_Money_Id, field: "B10", label: "10 บาท", image: "https://karatthai.com/wp-content/uploads/2016/12/10_baht_obverse_2551.png", type: "coin", value: pkCloseMoneyList.B10, multiplier: 10 },
            { id: pkCloseMoneyList.PKClose_Money_Id, field: "B5", label: "5 บาท", image: "https://s.isanook.com/ca/0/ud/280/1402335/i5.jpg?ip/resize/w728/q80/jpg", type: "coin", value: pkCloseMoneyList.B5, multiplier: 5 },
            { id: pkCloseMoneyList.PKClose_Money_Id, field: "B2", label: "2 บาท", image: "https://inwfile.com/s-cp/lab383.jpg", type: "coin", value: pkCloseMoneyList.B2, multiplier: 2 },
            { id: pkCloseMoneyList.PKClose_Money_Id, field: "B1", label: "1 บาท", image: "https://inwfile.com/s-cp/73riz8.jpg", type: "coin", value: pkCloseMoneyList.B1, multiplier: 1 }
        ];
    };

    // ฟังก์ชันเพิ่มค่า
    const handleMoneyIncrement = (index) => {
        setPkCloseMoneyList(prevAmounts =>
            prevAmounts.map((item, i) =>
                i === index ? { ...item, value: item.value + 1 } : item
            )
        );
    };

    // ฟังก์ชันลดค่า
    const handleMoneyDecrement = (index) => {
        setPkCloseMoneyList(prevAmounts =>
            prevAmounts.map((item, i) =>
                i === index && item.value > 0 ? { ...item, value: item.value - 1 } : item
            )
        );
    };

    // ยืนยันการปิดงาน Vansale
    const handleConfirm = () => {
        setShowConfirmDialog(false);
        handleSubmit();
    };

    // ปิดงาน Vansale
    const handleSubmit = async () => {
        try {
            // Disabled ปุ่มทันทีเมื่อระบบเริ่มทำงาน
            setIsDisabled(true);

            if (pkCloseMoneyList.length === 0) return getAlert('FAILED', 'ไม่พบข้อมูลของจำนวนเงินที่ได้รับจากลูกค้า กรุณาตรวจสอบข้อมูล');

            // สร้าง object ที่รวมข้อมูลทั้งหมดที่ต้องการอัพเดท
            const updateFormCloseMoney = {
                PKClose_Money_Id: pkCloseMoneyList[0].id,
                B1000: pkCloseMoneyList.find(item => item.field === "B1000")?.value || 0,
                B500: pkCloseMoneyList.find(item => item.field === "B500")?.value || 0,
                B100: pkCloseMoneyList.find(item => item.field === "B100")?.value || 0,
                B50: pkCloseMoneyList.find(item => item.field === "B50")?.value || 0,
                B20: pkCloseMoneyList.find(item => item.field === "B20")?.value || 0,
                B10: pkCloseMoneyList.find(item => item.field === "B10")?.value || 0,
                B5: pkCloseMoneyList.find(item => item.field === "B5")?.value || 0,
                B2: pkCloseMoneyList.find(item => item.field === "B2")?.value || 0,
                B1: pkCloseMoneyList.find(item => item.field === "B1")?.value || 0
            };
            await Axios.post(`${process.env.REACT_APP_API_URL}/api/update-pk-list-close-money`, updateFormCloseMoney, {
                headers: { key: process.env.REACT_APP_ANALYTICS_KEY }
            });

            // ลบของทุกอย่างออกจากรถ
            const warehouse = await getDataWithComp('Tb_Set_WH', `AND Flag_Vansale = 'Y' AND WH_Status = 'Y' AND WH_Code = '${deliveryCarNo}'`);
            await deleteData('WH_ITEM_Onhand', `WHERE WH_Id = ${warehouse[0].WH_Id}`);

            // อัพเดทสถานะข้อมูลใน PKList_H
            const response = await Axios.post(`${process.env.REACT_APP_API_URL}/api/update-status-pk-list-h`, {
                doc_id: pkId,
                doc_status: 5
            }, {
                headers: { key: process.env.REACT_APP_ANALYTICS_KEY }
            });

            if (response.data.status === 'OK') {
                setDocStatus(5);
                getAlert("OK", "ยืนยันการปิดงานสำเร็จ");
                hideVansaleCloseForAccount();
                setIsDisabled(false);
                callInitialize();
            }
        } catch (error) {
            setIsDisabled(false);
            getAlert("FAILED", "เกิดข้อผิดพลาดในการอัพเดทข้อมูล");
        }
    };

    // คำนวณรวมเงินสดทุกครั้งที่ pkCloseMoneyList เปลี่ยนแปลง
    useEffect(() => {
        const total = pkCloseMoneyList.reduce((acc, item) => acc + item.value * item.multiplier, 0);
        setTotalCash(total);
    }, [pkCloseMoneyList]);

    return (
        <>
            <div
                className={`modal fade ${isVansaleCloseForAccount ? 'show' : ''}`}
                style={{ display: isVansaleCloseForAccount ? 'block' : 'none' }}
                tabIndex="-1"
                role="dialog"
            >
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="d-flex align-items-center">
                                <h4 className="card-title">ปิดงานบัญชี</h4>
                            </div>
                            <button type="button" className="btn-close" onClick={hideVansaleCloseForAccount}></button>
                        </div>
                        <div className="modal-body" style={{ maxHeight: '700px', overflowY: 'auto', overflowX: 'hidden' }}>
                            <div className="row">
                                <div className="col-6 text-left">
                                    <h4 className="fw-bold text-black">ส่งสินค้า - {deliveryLineName}</h4>
                                </div>
                                <div className="col-6 text-end">
                                    <button className="btn btn-primary fw-bold btn-lg">
                                        ทะเบียนรถ - {deliveryCarNo}
                                    </button>
                                </div>
                            </div>

                            <br />

                            <div className="row d-flex align-items-center justify-content-between mb-4">
                                <div className="col d-flex align-items-center">
                                    <h5 className="fw-bold text-danger" style={{ fontSize: "18px", marginBottom: 0 }}>สรุปจำนวนเงิน</h5>
                                </div>
                            </div>

                            <div className="row g-2 mb-4">
                                {/* เงินสด */}
                                <div className="col-12 d-flex flex-column flex-md-row align-items-center">
                                    <div className="card" style={{ width: "100%", border: "1px solid gray" }}>
                                        <div className="card-body d-flex flex-column flex-md-row align-items-center">
                                            <span className="me-3 fw-bold" style={{ whiteSpace: "normal", wordWrap: "break-word", width: "100%", display: "inline-block" }}>
                                                เงินสด
                                            </span>
                                            <div className="input-group text-end" style={{ width: "auto", flexShrink: 0 }}>
                                                <span className="me-3 fw-bold" style={{ whiteSpace: "normal", wordWrap: "break-word", width: "100%", display: "inline-block", color: "#EF6C00" }}>
                                                    = {cash.toLocaleString('en-US', { style: 'currency', currency: 'THB' })}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* เงินโอน */}
                                <div className="col-12 d-flex flex-column flex-md-row align-items-center">
                                    <div className="card" style={{ width: "100%", border: "1px solid gray" }}>
                                        <div className="card-body d-flex flex-column flex-md-row align-items-center">
                                            <span className="me-3 fw-bold" style={{ whiteSpace: "normal", wordWrap: "break-word", width: "100%", display: "inline-block" }}>
                                                เงินโอน
                                            </span>
                                            <div className="input-group text-end" style={{ width: "auto", flexShrink: 0 }}>
                                                <span className="me-3 fw-bold" style={{ whiteSpace: "normal", wordWrap: "break-word", width: "100%", display: "inline-block", color: "#EF6C00" }}>
                                                    = {transfer.toLocaleString('en-US', { style: 'currency', currency: 'THB' })}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* เช็ค */}
                                <div className="col-12 d-flex flex-column flex-md-row align-items-center">
                                    <div className="card" style={{ width: "100%", border: "1px solid gray" }}>
                                        <div className="card-body d-flex flex-column flex-md-row align-items-center">
                                            <span className="me-3 fw-bold" style={{ whiteSpace: "normal", wordWrap: "break-word", width: "100%", display: "inline-block" }}>
                                                เช็ค
                                            </span>
                                            <div className="input-group text-end" style={{ width: "auto", flexShrink: 0 }}>
                                                <span className="me-3 fw-bold" style={{ whiteSpace: "normal", wordWrap: "break-word", width: "100%", display: "inline-block", color: "#EF6C00" }}>
                                                    = {cheque.toLocaleString('en-US', { style: 'currency', currency: 'THB' })}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* ค่าธรรมเนียม */}
                                <div className="col-12 d-flex flex-column flex-md-row align-items-center">
                                    <div className="card" style={{ width: "100%", border: "1px solid gray" }}>
                                        <div className="card-body d-flex flex-column flex-md-row align-items-center">
                                            <span className="me-3 fw-bold" style={{ whiteSpace: "normal", wordWrap: "break-word", width: "100%", display: "inline-block" }}>
                                                ค่าธรรมเนียม
                                            </span>
                                            <div className="input-group text-end" style={{ width: "auto", flexShrink: 0 }}>
                                                <span className="me-3 fw-bold" style={{ whiteSpace: "normal", wordWrap: "break-word", width: "100%", display: "inline-block", color: "#EF6C00" }}>
                                                    = {fee.toLocaleString('en-US', { style: 'currency', currency: 'THB' })}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* เครดิต */}
                                <div className="col-12 d-flex flex-column flex-md-row align-items-center">
                                    <div className="card" style={{ width: "100%", border: "1px solid gray" }}>
                                        <div className="card-body d-flex flex-column flex-md-row align-items-center">
                                            <span className="me-3 fw-bold" style={{ whiteSpace: "normal", wordWrap: "break-word", width: "100%", display: "inline-block" }}>
                                                เครดิต
                                            </span>
                                            <div className="input-group text-end" style={{ width: "auto", flexShrink: 0 }}>
                                                <span className="me-3 fw-bold" style={{ whiteSpace: "normal", wordWrap: "break-word", width: "100%", display: "inline-block", color: "#EF6C00" }}>
                                                    = {credit.toLocaleString('en-US', { style: 'currency', currency: 'THB' })}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* ค้างจ่าย */}
                                <div className="col-12 d-flex flex-column flex-md-row align-items-center">
                                    <div className="card" style={{ width: "100%", border: "1px solid gray" }}>
                                        <div className="card-body d-flex flex-column flex-md-row align-items-center">
                                            <span className="me-3 fw-bold" style={{ whiteSpace: "normal", wordWrap: "break-word", width: "100%", display: "inline-block" }}>
                                                ค้างจ่าย
                                            </span>
                                            <div className="input-group text-end" style={{ width: "auto", flexShrink: 0 }}>
                                                <span className="me-3 fw-bold" style={{ whiteSpace: "normal", wordWrap: "break-word", width: "100%", display: "inline-block", color: "#EF6C00" }}>
                                                    = {unpaid.toLocaleString('en-US', { style: 'currency', currency: 'THB' })}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <h5 className="text-end fw-bold">
                                รวมเงิน:{" "}
                                <span
                                    style={{
                                        color: "green",
                                    }}
                                >
                                    {formatCurrency(totalSell)}
                                </span>{" "}
                                บาท
                            </h5>

                            <hr />

                            <h5 className="fw-bold mb-4 text-left text-danger">กรอกจำนวนเงินสดที่ได้รับจากลูกค้า</h5>
                            <div className="row g-2 mb-4">
                                {pkCloseMoneyList.map((item, index) => (
                                    <div key={index} className="col-12 d-flex flex-column flex-md-row align-items-center">
                                        <div className="card" style={{ width: "100%", border: "1px solid gray" }}>
                                            <div className="card-body d-flex flex-column flex-md-row align-items-center">
                                                {/* พื้นที่แสดงรูปเงิน */}
                                                <div className="me-2" style={{ width: "120px" }}>
                                                    <img
                                                        src={item.image}
                                                        alt={item.label}
                                                        className={item.type === "coin" ? "img-fluid coin-image" : "img-fluid"}
                                                    />
                                                </div>

                                                {/* ป้ายจำนวนเงิน */}
                                                <div className="d-flex justify-content-center align-items-center" style={{ width: "20%" }}>
                                                    <span className="me-3 fw-bold" style={{ display: "inline-block" }}>
                                                        {item.label}
                                                    </span>
                                                </div>

                                                {/* จำนวนเงิน */}
                                                <div className="d-flex justify-content-center align-items-center" style={{ width: "80%" }}>
                                                    <span className="me-3 fw-bold text-danger" style={{ fontSize: "18px" }}>
                                                        {formatCurrency(item.value * item.multiplier)}
                                                    </span>
                                                    บาท
                                                </div>

                                                {/* ช่องกรอกจำนวน ปุ่ม - ปุ่ม + */}
                                                <div className="input-group text-end" style={{ width: "auto", flexShrink: 0 }}>
                                                    <button
                                                        className="btn btn-outline-warning"
                                                        style={{ width: "30px" }}
                                                        onClick={() => handleMoneyDecrement(index)}
                                                        disabled={isDisabled}
                                                    >
                                                        -
                                                    </button>
                                                    <input
                                                        type="text"
                                                        className="form-control text-center"
                                                        value={item.value}
                                                        readOnly
                                                        style={{ width: "60px" }}
                                                    />
                                                    <button
                                                        className="btn btn-outline-warning"
                                                        style={{ width: "30px" }}
                                                        onClick={() => handleMoneyIncrement(index)}
                                                        disabled={isDisabled}
                                                    >
                                                        +
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <h5 className="text-end fw-bold">
                                รวมเงิน:{" "}
                                <span
                                    style={{
                                        color: cash === totalCash ? "green" : "red",
                                    }}
                                >
                                    {formatCurrency(totalCash)}
                                </span>{" "}
                                บาท
                            </h5>
                            <h5 className="text-end fw-bold">
                                ส่วนต่าง:{" "}
                                <span
                                    style={{
                                        color: cash > totalCash ? "red" : "green",
                                    }}
                                >
                                    {cash === totalCash
                                        ? `${formatCurrency(0)}`
                                        : cash > totalCash
                                            ? `- ${formatCurrency(cash - totalCash)}`
                                            : `+ ${formatCurrency(totalCash - cash)}`}
                                </span>{" "}
                                บาท
                            </h5>
                        </div>
                        <div className="modal-footer">
                            <button
                                className="btn btn-lg btn-danger"
                                onClick={hideVansaleCloseForAccount}
                            >
                                ย้อนกลับ
                            </button>
                            {docStatus === 3 && (
                                <button
                                    className="btn btn-lg btn-success"
                                    onClick={() => setShowConfirmDialog(true)}
                                    disabled={isDisabled}
                                >
                                    ยืนยันปิดงาน
                                </button>
                            )}
                        </div>
                    </div>
                </div >
            </div >

            {isVansaleCloseForAccount && <div className="modal-backdrop fade show"></div>}

            {/* Confirm Dialog */}
            {showConfirmDialog && (
                <div className="modal fade show" tabIndex="-1" style={{ display: 'block' }}>
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title fw-bold">ยืนยันการปิดงานบัญชี</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setShowConfirmDialog(false)}
                                    aria-label="Close"
                                ></button>
                            </div>
                            <div className="modal-body">
                                <p>คุณแน่ใจว่าต้องการ ปิดงานบัญชี หรือไม่?</p>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-lg w-25 shadow text-white"
                                    style={{ backgroundColor: '#EF6C00', fontSize: '16px' }}
                                    onClick={handleConfirm}
                                >
                                    ยืนยัน
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-lg w-25 shadow text-white"
                                    style={{ backgroundColor: 'red', fontSize: '16px' }}
                                    onClick={() => setShowConfirmDialog(false)}
                                >
                                    ยกเลิก
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default CloseVansaleForAccountModal;